import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const mesAtual = useMemo(() => {
    const now = new Date();
    const mes = now.getMonth(); // 0-indexed
    const ano = now.getFullYear();
    // Se estiver na segunda metade do mês, mostra o próximo mês
    const dia = now.getDate();
    const mesExibido = dia > 15 ? (mes + 1) % 12 : mes;
    const anoExibido = dia > 15 && mes === 11 ? ano + 1 : ano;
    return `${MESES[mesExibido]} ${anoExibido}`;
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Show after user scrolls 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    // Google Analytics event tracking
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'click', {
        event_category: 'CTA',
        event_label: 'Floating Quote Button - Urgency',
        value: 1
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-20 left-6 z-40 animate-fade-in">
      <Link
        to="/contato"
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group flex items-center gap-3 cursor-pointer transition-all duration-300 hover:scale-105"
        aria-label="Request urgent quote - Limited availability"
      >
        {/* Urgency Badge */}
        <div className="absolute -top-3 -right-2 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse z-10"
          style={{ background: '#384774' }}>
          🔥 LIMITADO
        </div>

        {/* Text Label */}
        <div
          className={`text-white px-6 py-3 rounded-full shadow-lg transition-all duration-300 ${
            isHovered ? 'shadow-xl scale-105' : ''
          } border-2`}
          style={{
            background: 'linear-gradient(135deg, #384774 0%, #18c7f4 100%)',
            borderColor: 'rgba(24,199,244,0.5)',
          }}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-timer-line text-white text-lg animate-pulse"></i>
            </div>
            <div>
              <p className="font-body font-bold text-sm leading-tight whitespace-nowrap">
                ORÇAMENTO URGENTE
              </p>
              <p className="font-body text-xs text-white/80 whitespace-nowrap">
                ⏰ Apenas 3 vagas em {mesAtual}
              </p>
            </div>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-arrow-right-line text-white text-lg transition-transform duration-300 ${
                isHovered ? 'translate-x-1' : ''
              }`}></i>
            </div>
          </div>
        </div>

        {/* Floating indicator */}
        <div className="relative">
          <div className="w-3 h-3 rounded-full animate-pulse" style={{ background: '#18c7f4' }}></div>
          <div className="absolute inset-0 w-3 h-3 rounded-full animate-ping opacity-75" style={{ background: '#18c7f4' }}></div>
        </div>
      </Link>

      {/* Enhanced Tooltip with Urgency */}
      {isHovered && (
        <div className="absolute -top-20 left-1/2 transform -translate-x-1/2 text-white px-6 py-3 rounded-lg shadow-xl animate-fade-in whitespace-nowrap border-2"
          style={{ background: '#384774', borderColor: 'rgba(24,199,244,0.4)' }}>
          <div className="text-sm font-body font-bold">🚨 DISPONIBILIDADE LIMITADA</div>
          <div className="text-xs text-white/70">Somente 3 eventos restantes em {mesAtual}</div>
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full">
            <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent" style={{ borderTopColor: '#384774' }}></div>
          </div>
        </div>
      )}
    </div>
  );
}